<div class="form-multiinput">
  <div class="form-multiinput__container" [class.error]="errors && errors.length">
    @for (m of innerModel; track m; let n = $index) {
      <div
        class="form-multiinput__content"
        [class.active]="(tmpValue[n] || activeInput[n]) && !(errors && errors.length)"
        >
        <input
          class="form-multiinput__input-{{n}}"
          maxlength="1"
          type="text"
          [(ngModel)]="tmpValue[n]"
          pattern="[0-9]"
          [placeholder]="placeholder | translate"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus(n)"
          [class.form-multiinput--error]="errors && errors.length"
          [id]="currentInputId + '-' + n"
          [attr.name]="n"
          [attr.autocomplete]="n === 0 ? 'one-time-code' : null"
          [attr.inputmode]="'numeric'"
          [class.center]="centerTxtInput"
          />
      </div>
    }
  </div>
  @if (errors) {
    <div class="form-multiinput__error">{{ errors[0] }}</div>
  }
</div>
